<div class="quick-selection d-flex flex-column justify-content-between ">
    <rx-applications-pill
            class="mx-2 justify-content-between"
            *ngFor="let quickSelection of quickSelectionOptions"
            [selected]="quickSelection.days === selectedDays"
            [label]="quickSelection.label"
            [id]="quickSelection.days"
            [attr.data-qa]="testIdPrefix + '-pill-' + quickSelection.days"
            (toggle)="onQuickSelectionChange($event)"
    />
</div>

